import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  ButtonToolbar,
  Checkbox,
  DatePicker,
  FlexboxGrid,
  Form,
  SelectPicker,
} from "rsuite";

import "./MediaPlayFilters.css";
import { updateIn } from "json-immut";
import { HelperServices } from "../../../core/services/HelperServices";
import { get } from "lodash/fp";
import { MediaPlayListParams } from "./ReportDataTypes";
import {
  dateFormatObj,
  deviceTypeObjArr,
  fullDayTimeObjArr,
  mediaCatObjArr,
  mediaNatureObjArr,
  messageTypeArr,
  roleTypeArr,
  statusObjArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { StoreServices } from "../../../core/services/StoreServices";
import { getItemFor, isEmptyVal } from "../../../utils/helpers";
import moment from "moment";

export interface PropTypesInterface {
  onSubmit: Function;
  onClear: Function;
}

export default function MediaPlayFilters({
  onSubmit,
  onClear,
}: PropTypesInterface) {
  const { t } = useTranslation();
  const initSearchFormData = {
    company: "",
    store_group: "",
    region: "",
    store: UtilityServices.getLoggedInUser("store_id"),
    start_date: new Date(moment().format(dateFormatObj.moment_y_m_d)),
    end_date: new Date(moment().format(dateFormatObj.moment_y_m_d)),
    play_date: null,
    start_time: "",
    end_time: "",
    smart_search: "",
    media_search: "",
    media_category: "",
    media_nature: "",
    request_device_type: "",
  };
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] =
    useState<MediaPlayListParams>(initSearchFormData);
  const company = useSelector((state: any) => state.company);
  const [storeGroupList, setStoreGroupList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const handleSearchToggle = () => setShowFilter(!showFilter);

  function handleFormChanges(data: any) {
    let form = updateIn(formData, [data.path], data.value);
    setFormData(form);
  }

  function handleStoreChanges(value: any) {
    let form = formData;
    if (isEmptyVal(value)) {
      form = updateIn(form, ["store_group"], "");
      form = updateIn(form, ["store"], "");
    } else {
      form = updateIn(
        form,
        ["store_group"],
        getItemFor(value, "store_group_id", storeList)
      );
      form = updateIn(form, ["store"], value);
    }
    setFormData(form);
  }

  const handleDateChange = (date: any, frmIndex: any) => {
    let frmObj = { ...formData };
    frmObj[frmIndex] = date;
    setFormData({ ...frmObj });
  };

  const clearSearchDates = () => {
    formData.start_date = null;
    formData.end_date = null;
    setFormData({ ...formData });
  };

  async function init() {
    try {
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    storeGroupSearch("", company.id);
    storeSearch("", company.id);
  }, [company.id]);

  async function storeGroupSearch(searchGroup?: string, forComp?: number) {
    let compId: number = getCompanyId(forComp);

    if (!compId) {
      setStoreGroupList([]);
      return;
    }
    let params: any = { smart_search: searchGroup };
    if (compId) {
      params.company = compId;
      params.sort_by = "region_id";
      params.sort_order = "asc";
    }
    try {
      const res = await StoreServices.getStoreGroups(params);
      const respData = get("data.data", res);
      if (respData.length) {
        setStoreGroupList(respData);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function storeSearch(searchStore?: string, forComp?: number) {
    let compId: number = getCompanyId(forComp);

    if (!compId) {
      setStoreList([]);
      return;
    }
    let params: any = { smart_search: searchStore };
    if (compId) {
      params.company = compId;
      params.sort_by = "store_name";
      params.sort_order = "asc";
    }
    try {
      const res = await StoreServices.getStores(params);
      const respData = get("data.data", res);
      if (respData.length) {
        setStoreList(respData);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  function getCompanyId(forComp?: number) {
    let compId: number = 0;
    if (UtilityServices.getLoggedInUser("user_type") == roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (
      UtilityServices.getLoggedInUser("user_type") == roleTypeArr.backend
    ) {
      compId = forComp ? forComp : company.id;
    }
    return compId;
  }

  function clearSearch() {
    onClear();
    clearSearchDates();
    setFormData(initSearchFormData);
  }

  return (
    <div className="media-play-filter">
      <div className="row mb-2 media-play-filter-toggle-row">
        <ButtonToolbar>
          <Button className="media-play-filter-toggle" onClick={handleSearchToggle}>
            {" "}
            {t("MEDIA")} {t("PLAY")} {t("ADVANCE_SEARCH")}
          </Button>
        </ButtonToolbar>
      </div>
      {showFilter && (
        <div className="content mb-3 pb-0 media-play-filter-panel">
          <Form
            className="media-play-filter-form"
            formValue={formData}
            onChange={(data: any) => {
              let form = { ...formData, ...data };
              setFormData(form);
            }}
            layout="inline"
          >
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item>
                <Form.Group controlId="media_search">
                  <Form.ControlLabel>
                    {t("MEDIA")} {t("NAME")}
                  </Form.ControlLabel>
                  <Form.Control name="media_search" />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="media_category">
                  <Form.ControlLabel>
                    {t("MEDIA")} {t("CATEGORY")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={mediaCatObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "media_category", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({ path: "media_category", value: "" });
                    }}
                    name="media_category"
                    value={formData?.media_category}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="media_nature">
                  <Form.ControlLabel>
                    {t("MEDIA")} {t("TYPE")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={mediaNatureObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "media_nature", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({ path: "media_nature", value: "" });
                    }}
                    name="media_nature"
                    value={formData?.media_nature}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
            </FlexboxGrid>
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item>
                <Form.Group controlId="store_group">
                  <Form.ControlLabel>
                    {t("STORE")} {t("GROUP")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={storeGroupList}
                    onSearch={(e: any) => {
                      if (e) {
                        //storeGroupSearch(e);
                      }
                    }}
                    valueKey="id"
                    labelKey="region_group_name"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "store_group", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({ path: "store_group", value: "" });
                    }}
                    name="store_group"
                    value={formData?.store_group}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="store">
                  <Form.ControlLabel>{t("STORE")}</Form.ControlLabel>
                  <SelectPicker
                    data={storeList}
                    onSearch={(e: any) => {
                      if (e) {
                        storeSearch(e);
                      }
                    }}
                    valueKey="id"
                    labelKey="store_name"
                    onSelect={(value, item) => {
                      handleStoreChanges(value);
                    }}
                    onClean={(e: any) => {
                      storeSearch("");
                      handleStoreChanges("");
                    }}
                    name="store"
                    value={formData?.store}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="request_device_type">
                  <Form.ControlLabel>
                    {t("DEVICE")} {t("TYPE")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={deviceTypeObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "request_device_type", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "request_device_type",
                        value: "",
                      });
                    }}
                    name="request_device_type"
                    value={formData?.request_device_type}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
            </FlexboxGrid>
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item>
                <Form.Group controlId="start_date">
                  <Form.ControlLabel>
                    {t("START")} {t("DATE")}
                  </Form.ControlLabel>
                  <DatePicker
                    value={formData?.start_date}
                    format={dateFormatObj.calendar_d_m_y}
                    name="start_date"
                    id="start_date"
                    onChange={(e: any) => {
                      handleDateChange(e, "start_date");
                    }}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="end_date">
                  <Form.ControlLabel>
                    {t("END")} {t("DATE")}
                  </Form.ControlLabel>
                  <DatePicker
                    value={formData?.end_date}
                    format={dateFormatObj.calendar_d_m_y}
                    name="end_date"
                    id="end_date"
                    onChange={(e: any) => {
                      handleDateChange(e, "end_date");
                    }}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="start_time">
                  <Form.ControlLabel>
                    {t("START")} {t("TIME")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={fullDayTimeObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "start_time", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({ path: "start_time", value: "" });
                    }}
                    name={"start_hour"}
                    value={formData?.start_time}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="end_time">
                  <Form.ControlLabel>
                    {t("END")} {t("TIME")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={fullDayTimeObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "end_time", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({ path: "end_time", value: "" });
                    }}
                    name={"end_time"}
                    value={formData?.end_time}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
            </FlexboxGrid>
            <div className="filter-btn">
              <Button onClick={() => clearSearch()}>{t("CLEAR_FILTER")}</Button>
              <Button onClick={() => onSubmit(formData)}>{t("Search")}</Button>
            </div>
          </Form>
        </div>
      )}
    </div>
  );
}
